import { Box, TableCell } from "@mui/material"
import { ArrowDownwardOutlined, ArrowUpwardOutlined } from "@mui-symbols-material/w300"
import type { Header } from "@tanstack/react-table"
import { flexRender } from "@tanstack/react-table"
import type { ReactElement } from "react"
import { twMerge } from "tailwind-merge"

interface TableHeaderCellProps<TData> {
  header: Header<TData, unknown>
  align?: "left" | "center" | "right"
  className?: string
  flexibleSizing?: boolean
}

export const TableHeaderCell = <TData,>({
  header,
  align = "left",
  className,
  flexibleSizing = false,
}: TableHeaderCellProps<TData>): ReactElement => {
  const columnSize = header.getSize()

  const sizeStyles = flexibleSizing
    ? undefined
    : {
        width: columnSize,
        minWidth: columnSize,
        maxWidth: columnSize,
      }

  return (
    <TableCell
      key={header.id}
      align={header.id === "select" ? "center" : align}
      sx={sizeStyles}
      className={twMerge("z-[21]", className, header.column.getCanSort() ? "cursor-pointer" : "")}
      data-testid={`header-${header.id}`}
      onClick={header.column.getToggleSortingHandler()}
    >
      <Box className='flex items-center gap-x-2'>
        {header.column.getCanSort() &&
          {
            asc: <ArrowUpwardOutlined fontSize='small' />,
            desc: <ArrowDownwardOutlined fontSize='small' />,
            false: null,
          }[header.column.getIsSorted() as string]}
        {flexRender(header.column.columnDef.header, header.getContext())}
      </Box>
    </TableCell>
  )
}
